import {BaseForm} from "@overflo1/dynamic-form";
import {OperatorsEnum} from "@overflo1/full-table";


export const FamilyTranslations = {
  entityName: 'Famiglia',
  fields: {
    name: 'Nome',
    machineCount: "Num. Macchine",
    goToMachineTable: "Link",
    enabled: 'Attivo'
  }
}

export const FamilyFullTableConfig = {
  ignoreGeneratedColumns: false,
  allowedColumns: [
    'enabled',
    'name',
    'machineCount',
  ],
  columns: [{
    def: 'enabled',
    name: FamilyTranslations.fields.enabled,
    maxWidth: '60px'
  }
  ],
  join: [],
  defaultFilter: [{name: FamilyTranslations.fields.enabled, operation: OperatorsEnum.EQUALS, value: true}],
  enableUrlQueryParams: true,
}

export const FamilyDynamicFormConfig = {
  ignoreGeneratedForms: true,
  forms: [
    new BaseForm({
      key: 'name',
      required: true,
      label: 'Nome',
      controlType: 'text',
      readonly: false,
      fullWidth: false,
    })
  ],
  readonly: false,
}
